import { render, staticRenderFns } from "./page-cgu.vue?vue&type=template&id=bb12cbf6&"
import script from "./page-cgu.vue?vue&type=script&lang=js&"
export * from "./page-cgu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports